import React, { useEffect, useState } from 'react';
import { Modal, Form } from 'react-bootstrap';

import { ApiServiceServerless } from '../../../xhr_libs';
import AddEntityActionButtons from '../../forms/AddEntityActionButtons';
import { SOLAR_PROVIDER_LOOKUP } from '../../UtilityImportSettings/helpers/solar';

const DEFAULT_PROVIDER = { 'solar_provider_id': '', 'solar_provider_secret': '', 'solar_provider_type': 0 }

export default function EditOrganizationSolarProvider(props) {
  const { show, onHide, solarProvider, organizationId, refreshData, setIsLoading, showToast } =
    props;

  const [editSolarProvider, setEditSolarProvider] = useState({ ...DEFAULT_PROVIDER })


  const [actionsDisabled, setActionsDisabled] = useState(false);
  const [isLocalLoading, setIsLocalLoading] = useState(false);

  useEffect(() => {
    setEditSolarProvider({ ...solarProvider })
  }, [solarProvider])

  const updateSolarProvider = () => {
    setIsLocalLoading(true);
    let payload = {
      'solar_provider_id': editSolarProvider.solar_provider_id, 'solar_provider_secret': editSolarProvider.solar_provider_secret
    }

    ApiServiceServerless.post(
      `/solar/organization/${solarProvider.id}`,
      payload,
      { authorization_id: organizationId }
    )
      .then(() => {
        showToast('success', 'Success', 'Provider successfully updated');
        refreshData(organizationId, showToast, setIsLoading);
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
      })
      .finally(() => {
        setEditSolarProvider({ ...DEFAULT_PROVIDER })
        setIsLocalLoading(false);
        onHide();
      });
  };


  useEffect(() => {
    if (editSolarProvider.solar_provider_id === '') {
      setActionsDisabled(true)
    }
    else if ([1].includes(editSolarProvider.solar_provider_type)) {
      if (editSolarProvider.solar_provider_secret === '' || editSolarProvider.solar_provider_secret === null) {
        setActionsDisabled(true)
      }
      else {
        setActionsDisabled(false)
      }
    }
    else {
      setActionsDisabled(false)
    }
  }
    , [editSolarProvider])


  const updateField = (key, val) => {
    setEditSolarProvider((prev) => ({ ...prev, [key]: val }))
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton> Add Solar Provider</Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>
            {'Solar Provider Id'}
            <span className='text-warning font-weight-bold pl-1'>*</span>
          </Form.Label>
          <Form.Row>
            <Form.Control
              required
              value={editSolarProvider.solar_provider_id}
              onChange={(e) => updateField('solar_provider_id', e.target.value)}
            />
          </Form.Row>
        </Form.Group>

        <Form.Group>
          <Form.Label>Solar Provider Type</Form.Label>
          <Form.Control
            as='select'
            required
            value={editSolarProvider.solar_provider_type}
            disabled={true}

          >
            {Object.keys(SOLAR_PROVIDER_LOOKUP).map((opt) => (
              <option key={`day-opt-${opt}`} value={opt}>
                {SOLAR_PROVIDER_LOOKUP[opt]}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        {[1].includes(editSolarProvider.solar_provider_type) &&
          <Form.Group>
            <Form.Label>
              {'Solar Provider Secret'}
              <span className='text-warning font-weight-bold pl-1'>*</span>
            </Form.Label>
            <Form.Row>
              <Form.Control
                required
                value={editSolarProvider.solar_provider_secret}
                onChange={(e) => updateField('solar_provider_secret', e.target.value)}
              />
            </Form.Row>
          </Form.Group>}

      </Modal.Body>
      <Modal.Footer>
        <AddEntityActionButtons
          onCancel={onHide}
          onSubmit={updateSolarProvider}
          isSubmitting={isLocalLoading}
          submitDisabled={actionsDisabled}
        />
      </Modal.Footer>
    </Modal>
  );
}
